import { Result } from "@/schema/free-assessment/Result";
import { useTranslation } from "react-i18next";

interface ScoreTableProps {
  result: Result;
}

function ScoreTable({ result }: ScoreTableProps) {
  const { t } = useTranslation();

  return (
    <div className="rounded-lg border">
      <table className="w-full divide-y rounded-lg">
        <tbody>
          {result.categories.map((category) => (
            <tr
              key={category.id}
              className="border-b border-cool-gray-300 last:border-none"
            >
              <td className="px-6 py-4">{category.content}</td>
              <td className="px-6 py-4 text-end">
                <span className="text-lg font-medium text-cool-gray-900">
                  {category.points} /100
                </span>
              </td>
            </tr>
          ))}
          <tr>
            <td className="px-6 py-4 font-bold">{t("total")}</td>
            <td className="px-6 py-4 text-end">
              <span className="text-lg font-medium text-cool-gray-900">
                {result.total} /100
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default ScoreTable;
